import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { RootState } from "../app/store";
import { AUTH_STATUS_LOADING } from "../Constant";

export interface AuthState {
    isAuthenticated: boolean;
    type: number | null;
    hasBusiness: boolean;
    userId : number | null;
    name ?: string;
    status : number
}

const user = JSON.parse(localStorage.getItem("user") ?? "null");

const initialState: AuthState = {
    isAuthenticated: false,
    type: null,
    hasBusiness: false,
    userId: null,
    name: "",
    status : AUTH_STATUS_LOADING
};

export const AuthSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setAuth: (
            state,
            action: PayloadAction<{
                type: number;
                hasBusiness: boolean;
                userId: number | null;
                name?: string;
                status : number;
            }>
        ) => {
            state.isAuthenticated = true;
            state.type = action.payload.type;
            state.hasBusiness = action.payload.hasBusiness;
            state.userId = action.payload.userId;
            state.name = action.payload.name ?? "";
            state.status = action.payload.status;
        },
        clearAuth: (state) => {
            state.isAuthenticated = false;
            state.type = null;
            state.hasBusiness = false;
            state.userId = null;
            state.name = "";
        },
        setAuthStatus: (state, action: PayloadAction<number>) => {
            state.status = action.payload;
        },
    },
});

export const selectAuth = (state: RootState) => state.auth;

export const { setAuth, clearAuth, setAuthStatus } = AuthSlice.actions;

export const useIsUserLoggedIn = () => {
    const auth = useSelector(selectAuth);
    return auth.isAuthenticated;
};

export default AuthSlice.reducer;
